import './SidebarNav.css'
import SidebarNavLink from '../SidebarNavLink/SidebarNavLink';
import { IconHome, IconSchool, IconCertificate, IconHelpOctagon, IconMessage, IconTargetArrow, IconUser } from '@tabler/icons-react';
import { useConfigContext } from '../../../contexts/ConfigContext/ConfigContextProvider';



export default function SidebarNav() {
   const { jsonTexts, jsonFeatures } = useConfigContext();
   const texts = jsonTexts?.sidebar
   const viewTab = jsonFeatures?.appRoutes
   const isSubAuthorized = jsonFeatures?.subscriptionLevel

   const SIDEBAR_NAVLINKS = [
      {
         text: texts.home.text,
         icon: < IconHome className='sidebar-navLink--icon' size={32} />,
         to: texts.home.redirectTo,
         show: viewTab.home[isSubAuthorized]
      },
      {
         text: texts.misCursos.text,
         icon: < IconSchool className='sidebar-navLink--icon' size={32} />,
         to: texts.misCursos.redirectTo,
         show: viewTab.misCursos[isSubAuthorized]
      },
      {
         text: texts.misCertificados.text,
         icon: < IconCertificate className='sidebar-navLink--icon' size={32} />,
         to: texts.misCertificados.redirectTo,
         show: viewTab.misCertificados[isSubAuthorized]
      },
      {
         text: texts.foro.text,
         icon: < IconMessage className='sidebar-navLink--icon' size={32} />,
         to: texts.foro.redirectTo,
         show: viewTab.foro[isSubAuthorized]
      },
      {
         text: texts.oportunidades.text,
         icon: < IconTargetArrow className='sidebar-navLink--icon' size={32} />,
         to: texts.oportunidades.redirectTo,
         show: viewTab.oportunidades[isSubAuthorized]
      },
      {
         text: texts.perfil.text,
         icon: < IconUser className='sidebar-navLink--icon' size={32} />,
         to: texts.perfil.redirectTo,
         show: viewTab.miCuenta [isSubAuthorized]
      },
      {
         text: texts.ayuda.text,
         icon: < IconHelpOctagon className='sidebar-navLink--icon' size={32} />,
         to: texts.ayuda.redirectTo,
         show: viewTab.ayuda[isSubAuthorized]
      },
   ]

   return (
      <nav className='sidebar-nav-container'>
         {SIDEBAR_NAVLINKS?.filter(item => item.show).map(item => (
            < SidebarNavLink key={item.text} text={item.text} icon={item.icon} to={item.to} />
         ))}
      </nav>
   )
}
